var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spin-stage"},[_c('a-spin',{staticClass:"loadSpin",attrs:{"tip":"Carregando..."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }